export const DRAWER_WIDTH_PX = 260;

/** Tinggi maksimum shell nav kiri (selaras dengan area konten viewport). */
export const NAV_SHELL_MAX_HEIGHT = '95vh';

/** Scrollbar tipis/transparan untuk daftar menu nav kiri. */
export const navDrawerScrollSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'thin' as const,
  scrollbarColor: 'rgba(255, 255, 255, 0.14) transparent',
  '&::-webkit-scrollbar': {
    width: 5,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 4,
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
};

/** Scrollbar tipis untuk area konten utama (selaras dengan nav kiri). */
export const mainContentScrollSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'thin' as const,
  scrollbarColor: 'rgba(15, 23, 42, 0.18) transparent',
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(15, 23, 42, 0.12)',
    borderRadius: 4,
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(15, 23, 42, 0.22)',
  },
};
